import styled from 'styled-components'

const IconListUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-height: 450px;
  overflow-y: hidden;
`
export default IconListUi
